import React, { useEffect, useState } from "react";

import {
  ArrowBack,
  ArrowForward,
  Close,
  Fullscreen,
  Inventory2Outlined,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  ZoomIn,
} from "@mui/icons-material";

import "./UniverseGallery.css";
import imageone1 from "./homepage_images/home-images/Shop smarter with Universe POS-2.png";
import imageone2 from "./homepage_images/home-images/ecosystem_1.png";
import imageone3 from "./homepage_images/home-images/hero_2.png";
import imageone4 from "./homepage_images/home-images/hero_1.png";
import imageone5 from "./homepage_images/home-images/about_1.png";
import imageone6 from "./homepage_images/home-images/Inventory scanner in a modern aisle-4.png";
import imageone7 from "./homepage_images/home-images/Live business updates, beautifully connected-5.png";
import imageone8 from "./homepage_images/home-images/s2_realtime_pos_a.png";
import imageone9 from "./homepage_images/home-images/s2_stock_control_a.png";
import imageone11 from "./homepage_images/home-images/s2_warehouses_branches_a.png";
import imageone12 from "./homepage_images/home-images/s3_scanning_a.png";
import imageone13 from "./homepage_images/home-images/s4_purchasing_contacts_a.png";
import imageone14 from "./homepage_images/home-images/s4_deliveries_returns_a.png";
import imageone15 from "./homepage_images/home-images/Universe Scanner barcode scan-3.png";
import imageone16 from "./homepage_images/home-images/Universe POS in your pocket-1.png";

const GALLERY_ITEMS = [
  {
    id: 1,
    category: "Inventory Management",
    title: "Everything in one place.",
    description:
      "Monitor products, stock levels, quantities and inventory activity from a single powerful workspace.",
    image: imageone1,
  },
  {
    id: 2,
    category: "Point of Sale",
    title: "Sell faster with Universe POS.",
    description:
      "A streamlined point-of-sale experience designed to keep sales moving while inventory stays synchronized.",
    image: imageone2,
  },
  {
    id: 3,
    category: "Dashboard",
    title: "See your business clearly.",
    description:
      "Transform your business activity into meaningful information with a clean and intelligent dashboard.",
    image: imageone3,
  },
  {
    id: 4,
    category: "Barcode Scanning",
    title: "Scan. Identify. Move.",
    description:
      "Cam-Scanner makes barcode scanning fast and practical directly from your computer.",
    image: imageone4,
  },
  {
    id: 5,
    category: "Uni-Cloud",
    title: "Stay connected in real time.",
    description:
      "Receive real-time business notifications and stay informed about important activity wherever you are.",
    image: imageone5,
  },
  {
    id: 6,
    category: "Products",
    title: "Know what you have.",
    description:
      "Organize your products, SKUs and inventory information with a workspace built around your business.",
    image: imageone6,
  },
  {
    id: 7,
    category: "Business Operations",
    title: "Built for daily operations.",
    description:
      "Manage the movement of products through receiving, transfers, returns, adjustments and more.",
    image: imageone7,
  },
  {
    id: 8,
    category: "Business Intelligence",
    title: "Turn activity into insight.",
    description:
      "Understand what is happening across your business and make better decisions with useful information.",
    image: imageone16,
  },
];

const UniverseGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeCategory, setActiveCategory] = useState("All");

  const categories = [
    "All",
    ...new Set(GALLERY_ITEMS.map((item) => item.category)),
  ];

  const filteredItems =
    activeCategory === "All"
      ? GALLERY_ITEMS
      : GALLERY_ITEMS.filter((item) => item.category === activeCategory);

  const openLightbox = (item) => {
    setSelectedImage(item);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = "";
  };

  const showPrevious = () => {
    if (!selectedImage) return;

    const currentIndex = GALLERY_ITEMS.findIndex(
      (item) => item.id === selectedImage.id,
    );

    const previousIndex =
      currentIndex === 0 ? GALLERY_ITEMS.length - 1 : currentIndex - 1;

    setSelectedImage(GALLERY_ITEMS[previousIndex]);
  };

  const showNext = () => {
    if (!selectedImage) return;

    const currentIndex = GALLERY_ITEMS.findIndex(
      (item) => item.id === selectedImage.id,
    );

    const nextIndex =
      currentIndex === GALLERY_ITEMS.length - 1 ? 0 : currentIndex + 1;

    setSelectedImage(GALLERY_ITEMS[nextIndex]);
  };

  useEffect(() => {
    const handleKeyboard = (event) => {
      if (!selectedImage) return;

      if (event.key === "Escape") {
        closeLightbox();
      }

      if (event.key === "ArrowLeft") {
        showPrevious();
      }

      if (event.key === "ArrowRight") {
        showNext();
      }
    };

    window.addEventListener("keydown", handleKeyboard);

    return () => {
      window.removeEventListener("keydown", handleKeyboard);
      document.body.style.overflow = "";
    };
  }, [selectedImage]);

  return (
    <section className="universeGallery">
      {/* ================================================================
          BACKGROUND DECORATION
      ================================================================= */}

      <div className="universeGalleryGlow universeGalleryGlowOne" />
      <div className="universeGalleryGlow universeGalleryGlowTwo" />

      <div className="universeGalleryContainer">
        {/* ================================================================
            HEADER
        ================================================================= */}

        <div className="universeGalleryHeader">
          <div className="universeGalleryHeaderContent">
            <div className="universeGalleryIcon">
              <Inventory2Outlined />
            </div>

            <span className="universeGalleryEyebrow">
              INSIDE UNIVERSE INVENTORY
            </span>

            <h2>
              Built to make your
              <span> business visible.</span>
            </h2>

            <p>
              Explore the Universe Inventory ecosystem and discover the tools
              designed to help businesses manage inventory, sales, products and
              everyday operations with confidence.
            </p>
          </div>
        </div>

        {/* ================================================================
            CATEGORY FILTER
        ================================================================= */}

        <div className="universeGalleryFilters">
          {categories.map((category) => (
            <button
              type="button"
              key={category}
              className={
                activeCategory === category
                  ? "universeGalleryFilter universeGalleryFilterActive"
                  : "universeGalleryFilter"
              }
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {/* ================================================================
            GALLERY
        ================================================================= */}

        <div className="universeGalleryGrid">
          {filteredItems.map((item, index) => (
            <article
              key={item.id}
              className={
                index === 0
                  ? "universeGalleryItem universeGalleryItemFeatured"
                  : "universeGalleryItem"
              }
              onClick={() => openLightbox(item)}
            >
              <div className="universeGalleryImageWrapper">
                <img
                  src={item.image}
                  alt={item.title}
                  className="universeGalleryImage"
                  loading={index === 0 ? "eager" : "lazy"}
                />

                <div className="universeGalleryImageOverlay">
                  <div className="universeGalleryZoom">
                    <ZoomIn />
                  </div>

                  <div className="universeGalleryOverlayBottom">
                    <span>{item.category}</span>

                    <strong>{item.title}</strong>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* ================================================================
            BOTTOM STATEMENT
        ================================================================= */}

        <div className="universeGalleryBottom">
          <div className="universeGalleryBottomLine" />

          <div className="universeGalleryBottomContent">
            <span>One ecosystem.</span>

            <strong>Many possibilities.</strong>

            <span>Built around your business.</span>
          </div>

          <div className="universeGalleryBottomLine" />
        </div>
      </div>

      {/* ================================================================
          LIGHTBOX
      ================================================================= */}

      {selectedImage && (
        <div className="universeGalleryLightbox" onClick={closeLightbox}>
          <div
            className="universeGalleryLightboxContent"
            onClick={(e) => e.stopPropagation()}
          >
            {/* ============================================================
                LIGHTBOX HEADER
            ============================================================= */}

            <div className="universeGalleryLightboxHeader">
              <div className="universeGalleryLightboxMeta">
                <span>{selectedImage.category}</span>

                <strong>{selectedImage.title}</strong>
              </div>

              <button
                type="button"
                className="universeGalleryClose"
                onClick={closeLightbox}
                aria-label="Close gallery"
              >
                <Close />
              </button>
            </div>

            {/* ============================================================
                IMAGE
            ============================================================= */}

            <div className="universeGalleryLightboxImageArea">
              <button
                type="button"
                className="universeGalleryNavigation universeGalleryNavigationLeft"
                onClick={showPrevious}
                aria-label="Previous image"
              >
                <KeyboardArrowLeft />
              </button>

              <img
                src={selectedImage.image}
                alt={selectedImage.title}
                className="universeGalleryLightboxImage"
              />

              <button
                type="button"
                className="universeGalleryNavigation universeGalleryNavigationRight"
                onClick={showNext}
                aria-label="Next image"
              >
                <KeyboardArrowRight />
              </button>
            </div>

            {/* ============================================================
                LIGHTBOX FOOTER
            ============================================================= */}

            <div className="universeGalleryLightboxFooter">
              <div className="universeGalleryLightboxDescription">
                <p>{selectedImage.description}</p>
              </div>

              <div className="universeGalleryLightboxControls">
                <span className="universeGalleryCounter">
                  {GALLERY_ITEMS.findIndex(
                    (item) => item.id === selectedImage.id,
                  ) + 1}
                  {" / "}
                  {GALLERY_ITEMS.length}
                </span>

                <button
                  type="button"
                  onClick={showPrevious}
                  aria-label="Previous"
                >
                  <ArrowBack />
                </button>

                <button type="button" onClick={showNext} aria-label="Next">
                  <ArrowForward />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default UniverseGallery;
